import { motion } from 'framer-motion';
import './SplitText.css';

type Props = {
  text: string;
  className?: string;
  delay?: number;
  stagger?: number;
};

export function SplitText({ text, className = '', delay = 0, stagger = 0.04 }: Props) {
  const words = text.split(' ');
  return (
    <span className={`split ${className}`} aria-label={text}>
      {words.map((word, wi) => (
        <span className="split__word" key={wi}>
          {word.split('').map((char, ci) => (
            <span className="split__char-wrap" key={ci}>
              <motion.span
                className="split__char"
                initial={{ y: '110%' }}
                whileInView={{ y: '0%' }}
                viewport={{ once: true, margin: '-60px' }}
                transition={{
                  duration: 0.9,
                  delay: delay + (wi * 2 + ci) * stagger,
                  ease: [0.16, 1, 0.3, 1],
                }}
              >
                {char}
              </motion.span>
            </span>
          ))}
          {wi < words.length - 1 && <span className="split__space">&nbsp;</span>}
        </span>
      ))}
    </span>
  );
}
